import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 运行的渲染作业列表
  getRenderList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getRenderingTaskList', params)
  },
  // 完成的渲染作业列表
  getDoneRenderList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getDoneRenderList', params)
  },
  // 运行的渲染作业统计
  queryTaskOfPlatformStat (params) {
    return axios.post('/api/rendering/admin/task/rendering/queryTaskOfPlatformStat', params)
  },
  // 停止按钮
  stopTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/stopTask', params)
  },
  // 开始按钮
  startTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/startTask', params)
  },
  // 全速渲染按钮
  commitMainPictureRender (params) {
    return axios.post('/api/rendering/admin/task/rendering/commitMainPictureRender', params)
  },
  // 全速渲染优先帧
  handleMaxPriority (params) {
    return axios.post('/api/rendering/admin/task/rendering/handleMaxPriority', params)
  },
  // 全速渲染按钮
  fullSpeedRender (params) {
    return axios.post('/api/rendering/admin/task/rendering/commitFullSpeedRender', params)
  },
  // 查询共有的属性、要求、群组按钮
  getRenderingTaskCommonValue (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskCommonValue', params)
  },
  // 增加，修改，删除属性或者要求（多个任务和单个任务都适用）,群组不使用该方法
  handleRender (params) {
    return axios.post('/api/rendering/admin/task/rendering/HandleRender', params)
  },
  resetSingleRenderValue (params) {
    return axios.post('/api/rendering/admin/task/rendering/resetSingleTaskValue', params)
  },
  // 修改级别按钮
  updateLevel (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateLevel', params)
  },
  // 修改节点机数量按钮
  updateNodeLimit (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateNodeCount', params)
  },
  // 修改频率调度按钮
  updateFrequency (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateFrequency', params)
  },
  // 修改备注按钮
  updateRemark (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateRemark', params)
  },
  // 删除任务按钮
  deleteTask (params) {
    return axios.patch('/api/rendering/admin/task/rendering/deleteTask', params)
  },
  // 删除分析任务
  deleteAnalysisTask (params) {
    return axios.post('/api/rendering/admin/task/analyse/deleteAnalyse', params)
  },
  // 设置超时时间
  setTaskOverTime (params) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskOverTime', params)
  },
  // 导出作业Excel
  exportTaskExcel (params) {
    return exportAxios('/api/rendering/admin/task/rendering/exportGetWorkExcel', params)
  },
  // 导出扣费Excel
  exportCouFeeExcel (params) {
    return exportAxios('/api/rendering/admin/task/rendering/exportCouFeeExcel', params)
  },

  // 帧详情任务
  // 帧详情任务列表
  getTaskFrameRenderList (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskFrameRenderList', params)
  },
  // 重提帧任务
  recommitTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/recommitTaskFrame', params)
  },
  // 停止帧任务
  stopTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/stopTaskFrame', params)
  },
  // 中间存图并停止
  stopAndSaveTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/saveImageInMiddle', params)
  },
  // 开始帧任务
  startTaskFrame (params) {
    return axios.post('/api/rendering/admin/task/rendering/startTaskFrame', params)
  },
  // 查询帧耗时分布图以及帧完成情况
  getFrameCondition (params) {
    return axios.post('/api/rendering/admin/task/rendering/getFrameCondition', params)
  },
  // 查询配置详情
  loadingTaskParameter (params) {
    return axios.post('/api/rendering/admin/task/rendering/loadingTaskParameter', params)
  },
  // 查询配置文档名称
  getJsonFileName (params) {
    return axios.post('/api/rendering/admin/task/rendering/getJsonFileName', params)
  },
  // 查询配置文档
  getTaskJson (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskJson', params)
  },
  // 加载帧的缩略图
  loadingTaskThumbnail (params) {
    return axios.post('/api/rendering/admin/task/rendering/loadingTaskThumbnail', params)
  },
  // 加载帧的截图
  loadingTaskGrab (params) {
    return axios.post('/api/rendering/admin/task/rendering/loadingTaskGrab', params)
  },
  // 帧详情列表统计信息
  getFrameStatisticMessage (params) {
    return axios.post('/api/rendering/admin/task/rendering/taskRenderingConsume', params)
  },
  // 任务帧状态与卡帧计数
  getTaskFrameStatusCount (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskFrameStatusCount', params)
  },
  // 查询节点机信息
  getNodeInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getNodeInfo', params)
  },
  // 获取资源监控信息
  getResourceMonitor (params) {
    return axios.post('/api/rendering/admin/task/rendering/getResourceMonitor', params)
  },
  // 查看日志
  getRenderLog (params) {
    return axios.post('/api/rendering/admin/task/rendering/showLog', params)
  },
  // 查看错误信息、关键信息、未知节点
  getRenderErrorLog (params) {
    return axios.post('/api/rendering/admin/task/rendering/getRenderErrorInfo', params)
  },
  // 查看munu日志
  getMunuLog (params) {
    return axios.post('/api/rendering/admin/task/rendering/getRenderMunuLog', params)
  },
  // 查询渲染任务 AI 异常记录
  queryRenderTaskAiAbnormalRecordList (params) {
    return axios.post('/api/rendering/admin/task/rendering/queryTaskAiAbnormalRecordList', params)
  },
  // 查询分析任务 AI 异常记录
  queryAnalyseTaskAiAbnormalRecordList (params) {
    return axios.post('/api/rendering/admin/task/analyse/queryTaskAiAbnormalRecordList', params)
  },
  // 任务记录列表
  getTaskFrameConsumeInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskFrameConsumeInfo', params)
  },
  // 运行/完成的分析作业
  // 运行的分析作业列表//完成的分析作业列表   两个功能参数不同
  getAnalyseTaskList (params) {
    return axios.post('/api/rendering/admin/task/analyse/getAnalyseTaskList', params)
  },
  // 分析作业状态
  getAnalyseTaskStatus (params) {
    return axios.post('/api/rendering/admin/task/analyse/getAnalyseTaskStatus', params)
  },
  // 获取分析任务renderLog/debugLog（需要分析作业同步状态时把节点机ip和端口同步到本地）
  getAnalyseLog (params) {
    return axios.post('/api/rendering/admin/task/analyse/getAnalyseLog', params)
  },
  // 节点机列表
  // input节点机分布概览
  getNodeTaskListInput (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeTaskList', params)
  },
  // output节点机分布概览
  showGetNodeListOutput (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeTaskListOutput', params)
  },
  // 节点机概览统计数据
  showNodeData (params) {
    return axios.post('/api/rendering/admin/task/node/getNode', params)
  },
  // 全局搜索列表
  getGlobalSearchList (params) {
    return axios.post('/api/rendering/admin/task/common/getGlobalSearchList', params)
  },
  // 作业管理操作
  // 批量放弃
  abandonAnalyse (params) {
    return axios.post('/api/rendering/admin/task/analyse/abandonAnalyse', params)
  },
  // 预处理停止
  stopPreTask (params = {
    // taskIds: [590]   // [array] 任务id
  }) {
    return axios.post('/api/rendering/admin/task/pre/stopPreTask', params)
  },
  // 自动重提按钮（运行中渲染作业）
  updateAutoRestartLimit (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateAutoRestartLimit', params)
  },
  // 重提按钮(渲染作业)
  recommitTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/recommitTask', params)
  },
  // 重提按钮(分析作业)
  restartTask (params) {
    return axios.post('/api/rendering/admin/task/analyse/batchRestartAnalyseTask', params)
  },
  // 查询共有的属性、要求、群组按钮
  getTaskCommonValue (params) {
    return axios.post('/api/rendering/admin/task/common/getTaskCommonValue', params)
  },
   // 查询频率调度
  getFrequencyControl (params) {
    return axios.post('/api/rendering/admin/task/rendering/getFrequencyControl', params)
  },
  // 设置频率调度
  setFrequencyControl (params) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskScheduleRate', params)
  },
  // 增加属性（多个任务和单个任务都适用）
  analyseAddProperties (params) {
    return axios.post('/api/rendering/admin/task/analyse/addProperties', params)
  },
  preAddProperties (params) {
    return axios.post('/api/rendering/admin/task/pre/addProperties', params)
  },
  renderingAddProperties (params) {
    return axios.post('/api/rendering/admin/task/rendering/addProperties', params)
  },
  // 增加要求（多个任务和单个任务都适用）
  // 分析
  analyseAddRequirements (params) {
    return axios.post('/api/rendering/admin/task/analyse/addRequirements', params)
  },
  // 预处理
  preAddRequirements (params) {
    return axios.post('/api/rendering/admin/task/pre/addRequirements', params)
  },
  // 渲染
  renderingAddRequirements (params) {
    return axios.post('/api/rendering/admin/task/rendering/addRequirements', params)
  },
  // 增加群组（多个任务和单个任务都适用）
  // 分析
  analyseAddCategory (params) {
    return axios.post('/api/rendering/admin/task/analyse/addCategory', params)
  },
  // 预处理
  preAddCategory (params) {
    return axios.post('/api/rendering/admin/task/pre/addCategory', params)
  },
  // 渲染
  renderingAddCategory (params) {
    return axios.post('/api/rendering/admin/task/rendering/addCategory', params)
  },
  // 增加约束（多个任务和单个任务都适用）
  // 分析
  analyseAddConstraints (params) {
    return axios.post('/api/rendering/admin/task/analyse/addConstraints', params)
  },
  // 预处理
  preAddConstraints (params) {
    return axios.post('/api/rendering/admin/task/pre/addConstraints', params)
  },
  // 渲染
  renderingAddConstraints (params) {
    return axios.post('/api/rendering/admin/task/rendering/addConstraints', params)
  },

  // 删除属性
  // 分析
  analyseDeleteProperties (params) {
    return axios.post('/api/rendering/admin/task/analyse/deleteProperties', params)
  },
  // 预处理
  preDeleteProperties (params) {
    return axios.post('/api/rendering/admin/task/pre/deleteProperties', params)
  },
  // 渲染
  renderingDeleteProperties (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteProperties', params)
  },

  // 删除要求
  // 分析
  analyseDeleteRequirements (params) {
    return axios.post('/api/rendering/admin/task/analyse/deleteRequirements', params)
  },
  // 预处理
  preDeleteRequirements (params) {
    return axios.post('/api/rendering/admin/task/pre/deleteRequirements', params)
  },
  // 渲染
  renderingDeleteRequirements (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteRequirements', params)
  },
  // 删除群组
  // 分析
  analyseDeleteCategory (params) {
    return axios.post('/api/rendering/admin/task/analyse/deleteCategory', params)
  },
  // 预处理
  preDeleteCategory (params) {
    return axios.post('/api/rendering/admin/task/pre/deleteCategory', params)
  },
  // 渲染
  renderingDeleteCategory (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteCategory', params)
  },
  // 删除约束
  // 分析
  analyseDeleteConstraints (params) {
    return axios.post('/api/rendering/admin/task/analyse/deleteConstraints', params)
  },
  // 预处理
  preDeleteConstraints (params) {
    return axios.post('/api/rendering/admin/task/pre/deleteConstraints', params)
  },
  // 渲染
  renderingDeleteConstraints (params) {
    return axios.post('/api/rendering/admin/task/rendering/deleteConstraints', params)
  },
  // 获取属性要求约束群组（单个任务）
  // 分析
  analyseGetSingleStrategyForDataBase (params) {
    return axios.post('/api/rendering/admin/task/analyse/getSingleStrategyForDataBase', params)
  },
  // 预处理
  preGetSingleStrategyForDataBase (params) {
    return axios.post('/api/rendering/admin/task/pre/getSingleStrategyForDataBase', params)
  },
  // 渲染
  renderingGetSingleStrategyForDataBase (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSingleStrategyForDataBase', params)
  },
  // 重置属性，要求，群组(单个)
  resetSingleTaskValue (params) {
    return axios.post('/api/rendering/admin/task/common/resetSingleTaskValue', params)
  },
  // 查询所有群组
  queryCategory (params) {
    return axios.post('/api/rendering/admin/front/user/getTaskGroup', params)
  },
  // 获取预处理列表
  getPreTaskList (params) {
    return axios.post('/api/rendering/admin/task/pre/getPreTaskList', params)
  },
  // 获取任务帧总数及费用
  getSumFrameConsume (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSumFrameConsume', params)
  },
  // 重提预处理作业
  recommitPreTask (params) {
    return axios.post('/api/rendering/admin/task/pre/recommitPreTask', params)
  },
  // 恢复渲染作业
  regainTask (params) {
    return axios.post('/api/rendering/admin/task/rendering/regainTask', params)
  },
  // 恢复分析作业
  regainAnalyseTask (params) {
    return axios.post('/api/rendering/admin/task/analyse/regainAnalyse', params)
  },
  // 获取预处理木牛log
  getPreHandleLog (params) {
    return axios.post('/api/rendering/admin/task/pre/showLog', params)
  },
  // 获取预处理log
  getPerMunuLog (params) {
    return axios.post('/api/rendering/admin/task/pre/getRenderMunuLog', params)
  },
  // 渲染清空黑名单
  cleanRenderBlackList (params) {
    return axios.post('/api/rendering/admin/task/rendering/clearblacknodes', params)
  },
  // 预处理清空黑名单
  cleanPreBlackList (params) {
    return axios.post('/api/rendering/admin/task/pre/clearblacknodes', params)
  },
  // 分析清空黑名单
  cleanAnalyseBlackList (params) {
    return axios.post('/api/rendering/admin/task/analyse/clearblacknodes', params)
  },
  // 查看历史重渲记录
  getHistoryRenderInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getHistoryRenderInfo', params)
  },
  // 查看历史分析记录
  getHistoryAnalyseInfo (params) {
    return axios.post(' /api/rendering/admin/task/analyse/getHistoryAnalyseInfo', params)
  },
  // 查看预处理作业历史重渲记录
  getPreHistoryRenderInfo (params) {
    return axios.post('/api/rendering/admin/task/pre/getPreHistoryRenderInfo', params)
  },
  /**
   * 渲染设置超时停止时间
   * @param {Number} taskOverTime
   * @param {Array} taskIds
   */
  analysisSetTaskOverTimeStop ({taskIds, taskOverTime}) {
    return axios.post('/api/rendering/admin/task/analyse/setTaskOverTimeStop', {taskIds, taskOverTime})
  },
  /**
   * 预处理设置超时停止时间
   * @param {Number} taskOverTime
   * @param {Array} taskIds
   */
  preSetTaskOverTimeStop ({taskIds, taskOverTime}) {
    return axios.post('/api/rendering/admin/task/pre/setTaskOverTimeStop', {taskIds, taskOverTime})
  },
  /**
   * 渲染设置超时停止时间
   * @param {Number} taskOverTime
   * @param {Array} taskIds
   */
  setTaskOverTimeStop ({taskIds, taskOverTime}) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskOverTimeStop', {taskIds, taskOverTime})
  },
  // 拼图预览
  getJigsawPreview (params) {
    return axios.post('/api/rendering/admin/task/rendering/compoundTaskThumbnail', params)
  },
  // 用户输入输出路径
  getOutOrInputPath (params) {
    return axios.post('/api/rendering/admin/task/rendering/getOutOrInputPath', params)
  },
  // 单个用户所有金额统计
  queryAmount (params) {
    return axios.post('/api/rendering/admin/task/rendering/queryAmount', params)
  },
  // 查询账户信息
  queryAccountInfo (params) {
    return axios.post('/api/rendering/admin/task/rendering/getMainUserIdsByUserIds', params)
  },
  // 更新修改标签
  updateTaskLabel (params) {
    return axios.post('/api/rendering/admin/task/rendering/updateTaskLabel', params)
  },
  // 运行的作业，内存升级
  upgradeTaskRam (params) {
    return axios.post('/api/rendering/admin/task/rendering/upgradeTaskRam', params)
  },
  // 运行的作业，内存升级的信息查询
  advanceParameterSetting (params) {
    return axios.post('/api/rendering/admin/task/rendering/advanceParameterSetting', params)
  },
  // 新增管理员标签
  addAdminLabel (params) {
    return axios.post('/api/rendering/admin/base/tag/add', params)
  },
  // 删除管理员标签
  deleteAdminLabel (params) {
    return axios.post('/api/rendering/admin/base/tag/delete', params)
  },
  // 获取已选择的管理员标签
  queryTag (params) {
    return axios.post('/api/rendering/admin/task/common/queryTag', params)
  },
  // 删除已选择的管理员标签
  deleteAdminTag (params) {
    return axios.post('/api/rendering/admin/task/common/deleteAdminTag', params)
  },
  // 获取管理员标签
  getAdminLabel (params) {
    return axios.get('/api/rendering/admin/base/tag/list', params)
  },
  // 添加任务管理员标签
  addTaskAdminLabel (params) {
    return axios.post('/api/rendering/admin/task/common/addTag', params)
  },
  // 删除任务管理员标签
  deleteTaskAdminLabel (params) {
    return axios.post('/api/rendering/admin/task/common/deleteTag', params)
  },
  // 获取任务关联工单
  getJiraIssues (params) {
    return axios.post('/api/rendering/admin/base/getJiraIssues', params)
  },
  // 获取提交失败的错误信息
  getSubmitTaskFailMessage (params) {
    return axios.post('/api/rendering/admin/task/rendering/getSubmitTaskFailMessage', params)
  },
  // 修改任务硬件配置
  editTaskHardwareConfig (params) {
    return axios.post('/api/rendering/admin/task/rendering/editTaskHardwareConfig', params)
  },
  // 获取渲染节点机群组分布概览
  getNodeCategoryList (params) {
    return axios.post('/api/rendering/admin/task/node/getNodeCategoryList', params)
  },
  // 卡帧上报
  frameReporting(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/artificialReport', params)
  },
  // 查看停止原因
  queryStopReason(taskId) {
    return axios.post('/api/rendering/admin/task/rendering/queryStopReason', {taskId})
  },
  // 查询任务json文件定制列表
  queryTaskJsonFileCustomizationList(params) {
    return axios.post('/api/rendering/admin/task/config/task/queryTaskJsonFileCustomizationList', params)
  },
  // 校验任务json文件定制是否存在
  checkTaskJsonFileCustomization(params) {
    return axios.post('/api/rendering/admin/task/config/task/checkTaskJsonFileCustomization', params)
  },
  // 新增任务json文件定制
  addTaskJsonFileCustomization(params) {
    return axios.post('/api/rendering/admin/task/config/task/addTaskJsonFileCustomization', params)
  },
  // 根据id查询任务json文件定制
  queryTaskJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/task/queryTaskJsonFileCustomizationById', params)
  },
  // 根据id修改任务json文件定制
  editTaskJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/task/editTaskJsonFileCustomizationById', params)
  },
  // 据id删除任务json文件定制
  deleteTaskJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/task/deleteTaskJsonFileCustomizationById', params)
  },
  // 修改工单号
  setOrderNo(params) {
    return axios.post(' /api/rendering/admin/task/rendering/setOrderNo', params)
  },
  /**
   * 检查是否提示
   * @param {Array} taskIds
   * @param {number} type: 0 | 1 // 0: 任务, 1: 帧
   * @param {number} operateType 操作类型与前台枚举对应 1:开始 2:停止 4:重提 5:删除
   * @param {string} taskType 'pre' | 'post' | 'render'
   */
  // 检查是否提示
  checkShowTaskTip(params) {
    return axios.post('/api/rendering/admin/task/dependency/checkDependencyTask', params)
  },
  // 标记卡帧
  setTaskAbnormalSetting(params) {
    return axios.post('/api/rendering/admin/task/rendering/setTaskAbnormalSetting', params)
  },
  // 获取任务消费统计
  getRenderingTaskConsume(params) {
    return axios.post('/api/rendering/admin/task/rendering/getRenderingTaskConsume', params)
  },
  // 获取总任务数
  getRenderingTaskTotal(params) {
    return axios.post('/api/rendering/admin/task/rendering/getRenderingTaskTotal', params)
  },
  // 获取频率调度
  getTaskSchedule(params) {
    return axios.post('/api/rendering/admin/task/rendering/getTaskSchedule', params)
  },
}
